import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import {  useContext } from "react";
import {
	ChevronLeftIcon,
	ChevronRighttIcon,
} from '../../../styles/images/svg/ChevronIcons';

import { SidebarMenu } from './SidebarMenu';
import {Context} from "../../../_context/Store";

const drawerWidth = 300;

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));

export default function Sidebar(props) {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const [state, dispatch] = useContext(Context);

	
	const handleClick = () => {
		// setOpen(!open);
		if(state.ui_sidebar_open === true){
			dispatch({ type: "SIDEBAR_MENU_OPEN", payload: false });
		}
		else{
			dispatch({ type: "SIDEBAR_MENU_OPEN", payload: true });
		}
		
		if(state.ui_sidebar_menu_open === true){
			dispatch({ type: "SIDEBAR_TOGGLE", payload: false });
		}
		else{
			dispatch({ type: "SIDEBAR_TOGGLE", payload: true });
		}
		
	};

	return (
		<>
			<Drawer variant="permanent" open={state.ui_sidebar_menu_open} className="sbt-dashboard-drawer">
				<DrawerHeader>
					<IconButton
						onClick={handleClick}
						sx={{
							display: 'flex',
							width: '40px',
    						height: '40px',
							mt:'5px',
							ml:'5px',
							justifyContent: state.ui_sidebar_menu_open ? 'flex-start' : 'flex-end',
							marginRight: state.ui_sidebar_menu_open ? 'auto' : '5px',
						}}
					>
						<span className="sba-drawer-toggle-ic1n">
							{state.ui_sidebar_menu_open ? <ChevronLeftIcon /> : <ChevronRighttIcon />}
						</span>
					</IconButton>
				</DrawerHeader>
				<List className="sbt-dashboard-sidebar">
					<SidebarMenu open={state.ui_sidebar_menu_open} />
				</List>
			</Drawer>
		</>
	);
}
